module.exports = __webpack_public_path__ + "media/images/common/nav_1-ae3f3e9076baccc2ab8cc87999d85ee6.png";